export default {
  // Chưa nộp báo cáo
  Unsend: 10,
  // Cần sửa lại
  NeedToCorrect: 23,
  // Chờ nhận báo cáo
  WaitingReport: 15,
  // Đã nộp báo cáo
  Submited: 20,
  // Đã nộp lại báo cáo
  ReSubmited: 2,
  // Đã đồng ý
  Accepted: 30,
  // Đã ra biên bản
  RecordMade: 50,
  // Đã ra thông báo
  ReportMade: 70,
};
